import React from "react";
import { useNavigate } from "react-router-dom";

const RfqUnavailableNotice = ({
  title = "This RFQ is no longer available",
  message = "This invitation link is no longer active. The RFQ may have been deleted or your invitation access may have been removed.",
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F6F1] flex items-center justify-center px-4" style={{ fontFamily: "goldman_sans" }}>
      <div className="max-w-xl w-full rounded-3xl border border-[#E8DACB] bg-white p-8 shadow-[0_18px_60px_rgba(72,52,32,0.12)] text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#FFF2E8] text-[#D65A00] text-2xl font-bold">
          !
        </div>
        <h1 className="text-2xl font-semibold text-[#2F2A24]">{title}</h1>
        <p className="mt-3 text-sm leading-6 text-[#6F665D]">{message}</p>
        <div className="mt-7 flex flex-col sm:flex-row justify-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/leads")}
            className="rounded-full bg-[#ff6700] px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#e85d00]"
          >
            Go to Leads
          </button>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="rounded-full border border-[#D9C8B5] px-6 py-2.5 text-sm font-semibold text-[#594D43] hover:bg-[#F8F1EA]"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default RfqUnavailableNotice;
